import React, { useState, useEffect } from "react";

import { Row, Col, Button, Alert, Card, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { useStoreState, useStoreActions } from 'easy-peasy';
import DatePicker from "react-datepicker";

import { URLS } from '../../services/axios';

import AuthorizationChecker from '../../services/AuthorizationChecker';

import ActivitiesNumbers from '../../components/activities/ActivitiesNumbers';
import VideoPlayGraph from '../../components/activities/VideoPlayGraph';
import useCustomGetStoreState from "../../hooks/useCustomGetStoreState";
import SelectMultipleClientsComponent from "../../components/widgets/selectClient/SelectMultipleClientsComponent";
import Loader from "../../components/widgets/Loader";

import "./GlobalStatComponent.scss";

const GlobalStatComponent = () => {
    const { client: userClientUniqueId } = useStoreState(state => state.auth);
    const { apiData } = useStoreState(state => state.actionSlugs);
    const { initialFetchDone } = useStoreState(state => state.clients);

    const { allClients } = useCustomGetStoreState('clients');

    const [isFetching, setIsFetching] = useState(false);
    const [isFetchingNumbers, setIsFetchingNumbers] = useState(false);
    const [selectedClients, setSelectedClients] = useState([]);
    const [oneMonth, setOneMonth] = useState(true);

    const [minDate, setMinDate] = useState();
    const [maxDate, setMaxDate] = useState();
    const [isExpand, setIsExpand] = useState(false);
    const [datesFilter, setDatesFilter] = useState([undefined, undefined]);

    const { openWidgetContactForm } = useStoreActions(actions => actions.helpCenter);

    useEffect(() => {
        setSelectedClients(AuthorizationChecker.isAdmin() ? [] : allClients?.map(c => c.uniqueId));
    }, [allClients]);

    const toggleOneMonth = [
        { label: "30 derniers jours", value: true, defaultChecked: true },
        { label: "Depuis le début / autre période", value: false, defaultChecked: false }
    ];

    const downloadCSV = () => {
        const urlCSV = URLS.API_URL + apiData.URLs.getHeadsetActivityByCSV.url.replace('ClientID', userClientUniqueId).replace('activityID', 'all');
        window.open(urlCSV);
    }

    const downloadwebappActiviyCSV = () => {
        const urlCSV = URLS.API_URL + apiData.URLs.getwebappActivityByCSV.url.replace('ClientID', userClientUniqueId);
        window.open(urlCSV);
    }

    const RowActivityButton =
        <Row>
            <Col className="mb-3 d-flex justify-content-around align-items-center">
                <Button onClick={downloadCSV}><i className="fas fa-download" /> Activités casques</Button>
                <Button onClick={downloadwebappActiviyCSV}><i className="fas fa-download" /> Activités webapp</Button>
            </Col>
        </Row>;

    const dateFilter = <div className="d-flex align-items-center w-auto">
        <label className="label-select w-auto">Filtrer sur une période&nbsp;:</label>
        <div className="d-flex w-auto">
            <Button id="btnInitFilters" className="shadow" variant="danger" size="sm" onClick={() => setMinDate(null)}>
                <i className="fas fa-redo"></i>
            </Button>
            <DatePicker
                showIcon
                locale='fr'
                id='start'
                dateFormat="dd/MM/yyyy"
                selected={minDate}
                onChange={(date) => setMinDate(date)}
                placeholderText="jj/mm/aaaa"
                maxDate={maxDate}
            />
            <label htmlFor="end" className="m-2">&nbsp;au</label>
            <Button id="btnInitFilters" className="shadow" variant="danger" size="sm" onClick={() => setMaxDate(null)}>
                <i className="fas fa-redo"></i>
            </Button>
            <DatePicker
                showIcon
                locale='fr'
                id='end'
                dateFormat="dd/MM/yyyy"
                selected={maxDate}
                onChange={(date) => setMaxDate(date)}
                placeholderText="jj/mm/aaaa"
                minDate={minDate}
            />
            <Button id="btnInitFilters" className="shadow" variant="success" size="sm" onClick={() => setDatesFilter([minDate, maxDate])}>
                OK
            </Button>
        </div>
    </div>;

    return (initialFetchDone ? <>
        {!AuthorizationChecker.isAdmin() && RowActivityButton}

        {allClients?.length > 1 && <>
            <Row className="stats-select-clients">
                <Card className="contents_details_card">
                    <Card.Title className="contents_details_title d-flex justify-content-between mx-4 cursor-pointer"
                        onClick={() => setIsExpand(prev => !prev)}>
                        {selectedClients?.length +
                            (selectedClients?.length > 1
                                ? " établissements sélectionnés"
                                : " établissement sélectionné")
                            + " pour analyse"}
                    </Card.Title>
                    <Card.Body className={"contents_details_body" + (isExpand ? "" : " visually-hidden")}>
                        <SelectMultipleClientsComponent
                            disabled={isFetching || isFetchingNumbers}
                            nameSelect={`stats[clients][]`}
                            selectedClients={selectedClients}
                            setSelectedClients={setSelectedClients} />
                    </Card.Body>
                </Card>
            </Row>
            <div className="expand-btn cursor-pointer" onClick={() => setIsExpand(prev => !prev)}>
                {isExpand ? <i className="fa fa-angle-up fa-lg" /> : <i className="fa fa-angle-down fa-lg" />}
            </div>

        </>
        }
        {
            !allClients?.length && initialFetchDone ?
                <Alert variant="warning">
                    Pas d'abonnement actif pour analyse.<br />
                    Pour renouveler, veuillez contacter notre équipe commerciale à <Button as="a" bsPrefix={'no-btn'} onClick={() => { openWidgetContactForm() }}>
                        l'aide du formulaire de contact</Button>
                </Alert>
                : selectedClients?.length > 0 ?
                    <>
                        <Row className="my-3 justify-content-between">
                            <div className="d-flex align-items-center justify-content-between w-auto">
                                <ToggleButtonGroup className='py-2' type="radio" name="oneMonthCheck" id="oneMonthCheckSelect" value={oneMonth}
                                    onChange={() => setOneMonth((prev) => !prev)}>
                                    {toggleOneMonth.map(data =>
                                        <ToggleButton value={data.value} key={data.label} id={data.label}
                                            checked={oneMonth} className='mb-0' disabled={isFetching || isFetchingNumbers}>
                                            {data.label}
                                        </ToggleButton>
                                    )}
                                </ToggleButtonGroup>
                            </div>
                            {!oneMonth && dateFilter}
                        </Row>
                        <Row className="row-allcenter">
                            <ActivitiesNumbers clientsUniqueId={selectedClients}
                                setIsFetching={setIsFetchingNumbers} isFetching={isFetchingNumbers}
                                oneMonth={oneMonth} fromStatsPage={true}
                                datesFilter={datesFilter} />
                        </Row>
                        <Row className="row-allcenter video-graphs">
                            <VideoPlayGraph clientsUniqueId={selectedClients}
                                setIsFetching={setIsFetching} isFetching={isFetching}
                                oneMonth={oneMonth} fromStatsPage={true}
                                datesFilter={datesFilter} />
                        </Row>
                    </>
                    : <Alert variant="info">Merci de sélectionner au moins un établissement</Alert>
        }
    </>
        : <Loader />
    )
}

export default GlobalStatComponent;